export type VocSectionKey = 'board' | 'insight'

export const VOC_SUB_NAV: { k: VocSectionKey; ko: string; path: string }[] = [
  { k: 'board', ko: '게시글 목록', path: '/voc?section=board' },
  { k: 'insight', ko: 'VOC 현황/통계', path: '/voc?section=insight' },
]

export function vocSectionFromSearch(search: string): VocSectionKey {
  const section = new URLSearchParams(search).get('section')
  return section === 'insight' || section === 'status' || section === 'stats' ? 'insight' : 'board'
}
